module.exports = __webpack_public_path__ + "static/media/SWITCHING-YOUR-CAR.7c5dbf55.jpg";